import { FC } from 'react';

import { Text, TextProps } from '@chakra-ui/react';

const FooterListSubHeader: FC<TextProps> = ({ ...textProps }) => (
    <Text fontWeight="light" fontSize="md" {...textProps} />
);

export default FooterListSubHeader;
